import { render, staticRenderFns } from "./gfRecommendations.vue?vue&type=template&id=30000445"
import script from "./gfRecommendations.vue?vue&type=script&lang=js"
export * from "./gfRecommendations.vue?vue&type=script&lang=js"
import style0 from "./gfRecommendations.vue?vue&type=style&index=0&id=30000445&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports